import { getCommerceThemeConfig } from "../config/commerceThemes";

/**
 * Aplica los colores del comercio como CSS variables
 * Utiliza la configuración hardcodeada del archivo commerceThemes.ts
 */
export const applyCommerceTheme = (commerceId: number) => {
  if (!commerceId) return;

  const themeConfig = getCommerceThemeConfig(commerceId);
  const root = document.documentElement;
  
  if (themeConfig.primary_color) {
    root.style.setProperty('--bs-primary', themeConfig.primary_color);
    root.style.setProperty('--primary', themeConfig.primary_color);
    root.style.setProperty('--accent', themeConfig.primary_color);
    localStorage.setItem("commerce_primary_color", themeConfig.primary_color);
  }
  
  if (themeConfig.secondary_color) {
    root.style.setProperty('--bs-secondary', themeConfig.secondary_color);
    root.style.setProperty('--secondary', themeConfig.secondary_color);
    localStorage.setItem("commerce_secondary_color", themeConfig.secondary_color);
  }
  
  if (themeConfig.tertiary_color) {
    root.style.setProperty('--base', themeConfig.tertiary_color);
    root.style.setProperty('--bs-body-color', themeConfig.tertiary_color);
    localStorage.setItem("commerce_tertiary_color", themeConfig.tertiary_color);
  }

  if (themeConfig.logo_url) {
    localStorage.setItem("commerce_logo_url", themeConfig.logo_url);
  }
};

/**
 * Obtiene el logo del comercio actual desde la configuración
 */
export const getCommerceLogo = (commerceId?: number) => {
  // Si se proporciona commerceId, obtener directamente de la configuración
  if (commerceId) {
    const themeConfig = getCommerceThemeConfig(commerceId);
    return themeConfig.logo_url;
  }
  
  // Sino, intentar desde localStorage o usar el por defecto
  const logoUrl = localStorage.getItem("commerce_logo_url");
  return logoUrl || "/logo.png";
};

/**
 * Restaura los colores por defecto
 */
export const resetTheme = () => {
  const root = document.documentElement;
  root.style.removeProperty('--bs-primary');
  root.style.removeProperty('--primary');
  root.style.removeProperty('--accent');
  root.style.removeProperty('--bs-secondary');
  root.style.removeProperty('--secondary');
  root.style.removeProperty('--base');
  root.style.removeProperty('--bs-body-color');
};
